import { FacetRenderer } from "../rendering/renderable/Renderable";
import { Vector3 } from "flavr-math";
import { modelPool, computeLocalMatrixFromWorldMatrix, useExternalMessages } from "@modules/model";
const tmpPosition = new Vector3();
export class MovingToRenderable extends FacetRenderer {
    constructor(owner) {
        super(owner);
        this.owner = owner;
        this.update = (dt) => {
            if (this.facet === undefined)
                return;
            const rendererModelInterface = this.owner.renderer.getModel(this.facet.targetUid);
            if (rendererModelInterface === undefined) {
                this.unregisterAnimationCallback();
                return;
            }
            const movement = tmpPosition.subVectors(rendererModelInterface.worldPosition, this.owner.worldPosition);
            const length = movement.length();
            const vel = this.facet.linearSpeed * dt;
            this.owner.worldOrientation.slerp(rendererModelInterface.worldOrientation, vel);
            // reached?
            if (vel >= length) {
                this.owner.worldPosition.copy(rendererModelInterface.worldPosition);
                this.owner.worldOrientation.copy(rendererModelInterface.worldOrientation);
                if (this.facet.destroyOnReached) {
                    // it is necessary to send the messages via the bus?
                    this.destroyMe();
                }
                this.owner.matrixWorld.compose(this.owner.worldPosition, this.owner.worldOrientation, this.owner.worldScale);
                const messages = [];
                const model = modelPool.getModel(this.owner.modelUID);
                if (model !== undefined) {
                    const localMatrix = computeLocalMatrixFromWorldMatrix(model, this.owner.matrixWorld);
                    model.setTransform(localMatrix, useExternalMessages(messages));
                }
                this.owner.renderer.getConnection().sendMultiple(messages);
            }
            else {
                movement.normalize();
                movement.multiplyScalar(vel);
                this.owner.worldPosition.add(movement);
                this.owner.matrixWorld.compose(this.owner.worldPosition, this.owner.worldOrientation, this.owner.worldScale);
            }
            this.owner.updateTransform(this.owner.matrixWorld);
        };
    }
    destroy() { }
    setVisible() { }
    updateFacet() {
        this.registerAnimationCallback(this.update);
    }
    updateTransform(_1, _2, resultOfTimeStamp) {
        if (resultOfTimeStamp === undefined)
            return;
        if (resultOfTimeStamp <= this.updatedTime)
            return;
        // new Transform update after movingTo. Cancel movingTo
        this.destroyMe();
    }
}
